export * from './basicData';
export * from './customData';
export * from './basicData';
export * from './salaryProposal';
export * from './workingHours';
export * from './benefitProposal';
export * from './allowanceProposal';

export const TEXT_MAX_LENGTH = 80;
export const TEXT_LONG_MAX_LENGTH = 3000;
